// Angular
import { inject, PLATFORM_ID, REQUEST, REQUEST_CONTEXT } from '@angular/core';
import { HttpInterceptorFn, HttpEvent } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
// RxJS
import { Observable } from 'rxjs';

export const ClientIpInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<any>> => {

    // Inject necessary services
    const request = inject(REQUEST, { optional: true });
    const platformId = inject<Object>(PLATFORM_ID);

    const reqContext = inject(REQUEST_CONTEXT, { optional: true }) as {
        CLIENT_IP: string;
    };

    if (reqContext?.CLIENT_IP) {
        return next(
            req.clone({
                setHeaders: {
                    'X-Real-IP': reqContext?.CLIENT_IP || '',
                    'X-Forwarded-For': reqContext?.CLIENT_IP || '',
                    'user-agent': request?.headers.get('user-agent') + (isPlatformBrowser(platformId) ? ' (BROWSER)' : ' (NODEJS)')
                }
            })
        );
    }
    return next(req);
};
